import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  container: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  root: (props) => ({
    width: `${props.width}vw`,
    height: `${props.height}vw`,
    maxWidth: `${props.maxWidth}rem`,
    maxHeight: `${props.maxHeight}rem`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // paddingLeft: `${props.paddingLeft}rem`,
    // paddingRight: `${props.paddingRight}rem`,
  }),
  title: (props) => ({
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    // paddingTop: `${props.paddingHeaderTop}rem`,
    // paddingBottom: `${props.paddingHeaderBottom}rem`,
  }),
  boxLayout: (props) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),

  logo: (props) => ({
    maxHeight: `${props.sizeHeader}rem`,
  }),
});

export default useStyles;
